import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/32e393f5/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "general-guidance"
    }}>{`General guidance`}</h2>
    <p><em parentName="p">{`Notifications`}</em>{` are messages that communicate information to the user.`}</p>
    <h2 {...{
      "id": "format"
    }}>{`Format`}</h2>
    <h4 {...{
      "id": "title"
    }}>{`Title`}</h4>
    <p>{`All notifications have subject titles, which should be short and descriptive. (Example: “Tester-app-02 has crashed.”)`}</p>
    <h4 {...{
      "id": "message"
    }}>{`Message`}</h4>
    <p>{`We recommend the body of the notification be contained within two lines. Be descriptive and include any troubleshooting actions or next steps. When possible, communicate the main message using just the title. You can include `}<a parentName="p" {...{
        "href": "/components/link"
      }}>{`links`}</a>{` within the notification body that redirect the user to next steps.`}</p>
    <h4 {...{
      "id": "dismissal"
    }}>{`Dismissal`}</h4>
    <p>{`We recommend that toast notifications automatically disappear after five seconds. Inline notifications are persistent until the user dismisses them. All notifications have at least one method of dismissal (typically, it is a small “x” in the upper right hand corner).`}</p>
    <h4 {...{
      "id": "icons"
    }}>{`Icons`}</h4>
    <p>{`Icons may provide additional clarity. Icons should be placed to the left of a title. These glyphs (16x16) can be found in the `}<a parentName="p" {...{
        "href": "/guidelines/iconography/library"
      }}>{`iconography`}</a>{` library.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "36.141304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsSAAALEgHS3X78AAAAjklEQVQoz2NgwAMea5ozUA3cdzUD0y/czZmO2huxMDAwMi4y1wGLiYuLk27gVXmIgbflzYSPyBlLM3AzMP/XiCbPMBD4fwJi4P9z5iIfdxjLMjAwc/g5yLGQ7ULPKS5g2muGq7hrp4MikMmpbKLESraBDBX2ELrSgY2x1I4DxORx0yI/DEFAtMkRQ4yQYQDq8Bt2tLvRCAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The three icon states",
            "title": "The three icon states",
            "src": "/static/fa136b8d4258af4934d111fe4279565a/fb070/notification-usage-1.png",
            "srcSet": ["/static/fa136b8d4258af4934d111fe4279565a/d6747/notification-usage-1.png 288w", "/static/fa136b8d4258af4934d111fe4279565a/09548/notification-usage-1.png 576w", "/static/fa136b8d4258af4934d111fe4279565a/fb070/notification-usage-1.png 1152w", "/static/fa136b8d4258af4934d111fe4279565a/c3e47/notification-usage-1.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2 {...{
      "id": "variations"
    }}>{`Variations`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Notification type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Toast notification`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Toasts are a non-modal, time-based window elements used to display short messages; they usually appear at the bottom of the screen and disappear after a few seconds.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Inline notification`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Inline notifications show up in task flows, to notify users of the status of an action. They usually appear at the top of the primary content area.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "placement"
    }}>{`Placement`}</h2>
    <h4 {...{
      "id": "toast-notifications"
    }}>{`Toast notifications`}</h4>
    <p>{`Toast notifications slide in and out a page from the top-right corner. Actionable notifications do not appear on mobile screen widths.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.233695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACFUlEQVQoz32QP2/TUBTFE2AAKanSqkhJlAx8BFbGSszARIGJAQEJUCoWpIqxA1+gFepYCZWCimBhQqgsqIlQMyDUUJI4sR07/hvHTuzacQ73PdHSAeVJP717z/M91/cm8vk8stnsVHK5HGbn5pBOp5GemfkH5ZlMBvMX5+NCoYBisbiYSKVSd4lF4vb/oMI755LJm7euXV9dLj/aWCqV1pbL5XXG0sPS+tNSee3Z4yevri4sPE+ePVNIAPhIbBKvp7CJ361fEDqu29MspyPaXlex/Z5mB5puIDga0zc3EuxQgCiKMO1MwhCxrCCiWrsjwWpL6ItdBLqJUc8AwhhDRb13Yui6rk9EpxkMBhzX8yJH16NIlOOxaU8CuTOBIU1gyhNoFI/MkHft9x+cGFJhSOA0nudhSDiOA0PT0Fd7CB0Tn/YsrGwNsbrj4cUbL17ZDvHyg9//WR9c5obtdhv1ej1stVpoNBpoNpssR6VSQbVaRa1W49pho4n9/e/4vHeA7d0O3n0V8Ha3PX7/TcXWF+Hg/saP89yQxgOZhrIsQ1VVDotZA0EQOF3Ke6QLQhuaKsO1VAxMBQNLicOhRbnSIG32ZGRd10PbtvmY3t8xTdOEZVkwDIPW0+c6yx22Etc7Jj4KI3YfDkf+BW7o+z5EUYw02tPx/piZJElQFIX/LTNlerfb5W8sZk2JOAgCdreo2RV6u/QHQjBehvmh9BgAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Toast notification example",
            "title": "Toast notification example",
            "src": "/static/fdd85ccb991c9119f2ef4283b690b5cf/fb070/notification-usage-2.png",
            "srcSet": ["/static/fdd85ccb991c9119f2ef4283b690b5cf/d6747/notification-usage-2.png 288w", "/static/fdd85ccb991c9119f2ef4283b690b5cf/09548/notification-usage-2.png 576w", "/static/fdd85ccb991c9119f2ef4283b690b5cf/fb070/notification-usage-2.png 1152w", "/static/fdd85ccb991c9119f2ef4283b690b5cf/c3e47/notification-usage-2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h4 {...{
      "id": "inline-notifications"
    }}>{`Inline notifications`}</h4>
    <p>{`Inline notifications appear near its related item. In `}<a parentName="p" {...{
        "href": "/components/form"
      }}>{`forms`}</a>{`, we recommend placing the inline notification at the bottom of the form, right before the submission buttons. Depending on the context of the page, inline notifications can appear above the content as well.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "113.45108695652175%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAACXBIWXMAAAsSAAALEgHS3X78AAADgUlEQVQ4y62VXU/bZhTHcYKWqV13E5ogxUBFRyckEBLc7KZTJS62D4Aaab1wXwSTKu0D7AK2kd70BmmTBhO0QqiaNhVBgTGgpEko4s1tx0hEaWpKgmMnsRO/J2lTyPCOH9Ipq1NVVD3ST//nRec85/E5tisqiuZ0OhGl49L5O5vL5frfvLq6+t0CNTc3I21ra7M0NjbWNDU14V1dXTZd1y0sy1o1TUNkMplSkM8rNRk4HzmRbDZbfiMajSLlOO5YOBy+xDDMV8lk8nw6nXbncjk3ZIGAAAbngQuAqxgUMwVUVRUrZnkSApFwQIim6Q0Yh2AvJMtyKRvANnDO8AG1vLcrFwoFrOwGXA1tKIpih6zmE4lEANQvCMIsZPgnXHemhGnAB3xWLIo5QwiENJ/Pf5RKpb6FgD08z3cbCod9J4piTwndwDXgU8MH1Jyl2+1G2t7ebunt7bUZ4+Hh4bc+hjfuS5KETins71fH43EGqp3OaBoH1+Vfw1hLABrwRbGgVlNAMrKDNKjK1kVy7VR4ZwdPShJOcxweicfxaMIggUdYBt9VFVfsxfOaXVn60PChc2V6kfp9FOlm30/HIyurnamtJwQfDBHi462L6lOKUMIGTwl1+xkhP/yLEBaXrojLqzXoGQbum5+hePfeYZVv/VYlhDbXIGCQp7ZJMbpLqjGGVGIxUqFjpMrGSXnryaqw/ndQ3Ah+jnwfPLJUvC/L6Hr5PhSkw9IXDv6pohlmOcnza9lcbhk+CCvQZ6+zBAVbBz37xj4Us4dfjH394BgrCpcTHPe1oqpdkqIAclEPSQlCZ1oUr6YFoc7wgbk5y+TtcbT4bGjYnr2/NKbuRKeESHRC2aUnVTo2mWHjkxmGndRizMSBJN/ZS6Xn9tICelNgbvH7/eUbFNSmR2M/6rnnv+gv8v36y70BfW9/IM/xAxB0IBdP9MP6z7qq3dQP9DPIR9XMV65yONCiw+n88mPHyb7jJ058b62s9MCS5wObzTM4NOTx+f2emdlZzx/T0z/MzM1d997zdho+v47erjBliOO4tfgL+KahoSH1yenTWzCmnA4HVVdXR42MjFALCwvU/Pw85fV6w36fj4UgNwyfQCCAmQIa1tLScuS2gUPKb7S2tv73byEIAuvo6MDq6+sxu92O1dbWYoODg9jU1BQ2NjaGjY+PY5ClkRUqpM/nQxj2LzdknTwpjRI0AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Form example with inline notification",
            "title": "Form example with inline notification",
            "src": "/static/cda1826e4cf1266ab805e62922c3bced/fb070/notification-usage-3.png",
            "srcSet": ["/static/cda1826e4cf1266ab805e62922c3bced/d6747/notification-usage-3.png 288w", "/static/cda1826e4cf1266ab805e62922c3bced/09548/notification-usage-3.png 576w", "/static/cda1826e4cf1266ab805e62922c3bced/fb070/notification-usage-3.png 1152w", "/static/cda1826e4cf1266ab805e62922c3bced/c3e47/notification-usage-3.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      